import React from 'react';

import { ReactComponent as ArrowIcon } from './arrow_sort.svg';
import { FLAGGED_PLAYERS_LIMIT } from '../../../../../config/constants';
import { ATHeader as ATHProps } from '../../types';
import { useTablePropertiesDispatch, useTablePropertiesState } from 'store/hooks';

const ATHeader = ({ headers, sortedPlayers, setExpandedAcc } : ATHProps) => {

  const { pinnedRows = [], orderColumn = 0 } = useTablePropertiesState();
  const { changePinnedRows, changeOrderColumn } = useTablePropertiesDispatch();

  const handleHeaderFlagClicked = () => {
    if (pinnedRows.length && pinnedRows.length === FLAGGED_PLAYERS_LIMIT) {
      setExpandedAcc([]);
      changePinnedRows([])();
    } else {
      const playerIds = sortedPlayers.slice(0, FLAGGED_PLAYERS_LIMIT).map(player => player.playerId);
      changePinnedRows(playerIds)();
    } 
  };

  const handleSortableHeaders = (index: number) => {
    if (index !== Math.abs(orderColumn)) changeOrderColumn(index)();
    else if (orderColumn > 0) changeOrderColumn(-index)();
    else changeOrderColumn(0)();
  };

  return (
    <tr 
      style={{ top: 0, position: 'sticky', zIndex: 3 }}
      className="nvd-custom-table-thead-tr-head OGCY-fixed-vertical" 
    >
      {headers.map((header, index) => {
        if (header.isPinFlagCell) {
          return (
            <th key={index} style={header.style}>
              <img
                src={`/assets/flag-0${pinnedRows.length === FLAGGED_PLAYERS_LIMIT ? '3' : '2'}.svg`}
                onClick={handleHeaderFlagClicked}
                height="13" width="13" alt="icon" />
            </th>
          );
        } else {
          return (
            <th
              key={index + 1}
              style={header.style}
              onClick={() => handleSortableHeaders(index + 1)}
            >
              {header.content}
              {index + 1 === Math.abs(orderColumn) &&
                <ArrowIcon
                  className={orderColumn > 0 ? "arrow-icon" : "arrow-icon arrow-icon-up"}
                />
              }
            </th>
          );
        }
      })}
    </tr>
  );
};

export default ATHeader;